module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1170.ebda46d2.png";